import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const useReconciliationServiceIntegrationBeta2Flag = (): boolean =>
  useBooleanFlagValue('reconciliation-service-integration-beta-2', false);
